import { Box } from '@modusign/design-system';
import { ReactNode } from 'react';

const defaultProps = {
  uploadType: 'GOOGLE_DRIVE',
};

export type DropZoneTabUploadType = 'BOX' | 'DROPBOX' | 'GOOGLE_DRIVE' | 'ONE_DRIVE';

interface UpLoadModalDropZoneTabProps {
  uploadType: DropZoneTabUploadType;
  onClick: (uploadType: DropZoneTabUploadType) => void;
}

function UpLoadModalDropZoneTab({ onClick, uploadType }: UpLoadModalDropZoneTabProps) {
  return (
    <Box
      borderBottom="1px solid"
      borderBottomColor="buttonBorderNeutralSlightlyLight"
      pt="16px"
      textAlign="center"
    >
      <TabMenuItem isActive={uploadType === 'GOOGLE_DRIVE'} onClick={() => onClick('GOOGLE_DRIVE')}>
        Google Drive
      </TabMenuItem>
      <TabMenuItem isActive={uploadType === 'DROPBOX'} onClick={() => onClick('DROPBOX')}>
        DropBox
      </TabMenuItem>
      <TabMenuItem isActive={uploadType === 'ONE_DRIVE'} onClick={() => onClick('ONE_DRIVE')}>
        One Drive
      </TabMenuItem>
      <TabMenuItem isActive={uploadType === 'BOX'} onClick={() => onClick('BOX')}>
        Box
      </TabMenuItem>
    </Box>
  );
}

UpLoadModalDropZoneTab.defaultProps = defaultProps;

export default UpLoadModalDropZoneTab;

function TabMenuItem({
  children,
  isActive,
  onClick,
}: {
  children: ReactNode;
  isActive: boolean;
  onClick: () => void;
}) {
  return (
    <Box
      as="button"
      borderBottom={isActive ? '3px solid' : undefined}
      borderBottomColor={isActive ? 'boxBorderPrimaryDark' : undefined}
      color={isActive ? 'textNeutralSlightlyLight' : 'textNeutralLight'}
      display="inline-block"
      fontWeight={isActive ? 'bold' : 'button'}
      minWidth="100px"
      pb="10px"
      sx={{
        '&:hover': {
          fontWeight: 'bold',
        },
      }}
      type="button"
      onClick={onClick}
    >
      {children}
    </Box>
  );
}
